// TextPreview.tsx
import { useEffect, useState } from "react";

interface TextPreviewProps {
  url: string;
  type: string;
}

export const TextPreview = ({ url, type }: TextPreviewProps) => {
  const [content, setContent] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTextContent = async () => {
      try {
        const response = await fetch(url);
        const text = await response.text();
        setContent(text);
        setLoading(false);
      } catch (err) {
        setError("Failed to load file content");
        setLoading(false);
      }
    };

    fetchTextContent();
  }, [url]);

  if (loading) {
    return <div className="text-center py-8">Loading content...</div>;
  }

  if (error) {
    return <div className="text-red-500 text-center py-8">{error}</div>;
  }

  // Format based on file type
  if (type === "application/json") {
    try {
      const formattedJson = JSON.stringify(JSON.parse(content), null, 2);
      return (
        <pre className="whitespace-pre-wrap break-words text-sm font-mono">
          {formattedJson}
        </pre>
      );
    } catch {
      // If JSON parsing fails, just show as plain text
      return (
        <pre className="whitespace-pre-wrap break-words text-sm">{content}</pre>
      );
    }
  }

  // For code-like content
  if (
    type === "text/javascript" ||
    type === "text/css" ||
    type === "text/html"
  ) {
    return (
      <pre className="whitespace-pre-wrap break-words text-sm font-mono">
        {content}
      </pre>
    );
  }

  // Default for text files
  return (
    <pre className="whitespace-pre-wrap break-words text-sm">{content}</pre>
  );
};
